export enum KeyCode {
  ESCAPE = 27,
  ARROW_KEY_UP = 38,
  ARROW_KEY_DOWN = 40,
  ENTER = 13,
  BACKSPACE = 8,
  DELETE = 46,
}
